var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBodyWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4402_21929)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4402_21929",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4402_21929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.06757 14.6719L0.363131 4.29028C0.218569 2.15953 1.90677 0.351564 4.04099 0.351564H19.9588C22.093 0.351564 23.7812 2.15953 23.6366 4.29028L22.5564 20.2095C22.4251 22.1453 20.8176 23.6484 18.8786 23.6484H5.12122C3.18224 23.6484 1.57466 22.1453 1.44332 20.2095L1.19797 16.5938",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9687 8.17969H6.70312C6.70312 5.25431 9.07462 2.88281 12 2.88281C14.9254 2.88281 17.2969 5.25431 17.2969 8.17969H15.8906",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6133 3.20609L10.8491 4.08594",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31396 4.57464L8.95807 5.21875",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6246 4.48089L14.9805 5.125",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2895 3.1748L13.0537 4.05469",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0469 8.15625L10.4297 5.27344",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42969 3.49219C4.42969 3.98409 4.03097 4.38281 3.53906 4.38281C3.04716 4.38281 2.64844 3.98409 2.64844 3.49219C2.64844 3.00028 3.04716 2.60156 3.53906 2.60156C4.03097 2.60156 4.42969 3.00028 4.42969 3.49219Z",
    fill: "#3ABBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3516 3.49219C21.3516 3.98409 20.9528 4.38281 20.4609 4.38281C19.969 4.38281 19.5703 3.98409 19.5703 3.49219C19.5703 3.00028 19.969 2.60156 20.4609 2.60156C20.9528 2.60156 21.3516 3.00028 21.3516 3.49219Z",
    fill: "#3ABBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50781 20.3203C5.50781 20.8122 5.10909 21.2109 4.61719 21.2109C4.12528 21.2109 3.72656 20.8122 3.72656 20.3203C3.72656 19.8284 4.12528 19.4297 4.61719 19.4297C5.10909 19.4297 5.50781 19.8284 5.50781 20.3203Z",
    fill: "#3ABBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2734 20.3203C20.2734 20.8122 19.8747 21.2109 19.3828 21.2109C18.8909 21.2109 18.4922 20.8122 18.4922 20.3203C18.4922 19.8284 18.8909 19.4297 19.3828 19.4297C19.8747 19.4297 20.2734 19.8284 20.2734 20.3203Z",
    fill: "#3ABBC7"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15042 16.799C6.54134 17.8521 7.42667 18.563 8.50833 18.6928L12.7001 19.1978C15.3089 19.512 18.0146 18.0291 19.4878 15.4775C20.2869 14.0934 19.237 12.5478 17.8094 13.0079C15.8783 13.6311 13.8926 13.8279 11.9797 13.5843L8.86191 13.188C7.04752 12.9573 5.49243 15.0289 6.15042 16.799Z",
    fill: "#EBE298"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4402_21929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyWeight);
export default __webpack_public_path__ + "static/media/body-weight.b127dfe246f99a1ddc69f42c39efe988.svg";
export { ForwardRef as ReactComponent };